import { createActions } from 'reduxsauce'

const { Types: DuplicateNFTsTypes, Creators: DuplicateNFTsActions } = createActions({
    resetDuplicateNftsData: null,
    getDuplicateNftsData: ['loading'],
    setDuplicateNftsData: ['collections', 'hasDataToLoad',],
    updateDuplicateNftsData: ['data'],
    setDuplicateNftsActiveChain: ['data'],
})

export { DuplicateNFTsTypes, DuplicateNFTsActions }
